import React, { Fragment } from 'react';
import { hasAny } from '../utils';

const Street = ({ street, number, aptNumber }) =>
  hasAny(street, number) ? (
    <div>
      {street} {number}
      {!!aptNumber && ' '}
      {!!aptNumber && aptNumber}
    </div>
  ) : null;

const Address = ({ address1, address2 }) => (
  <div>
    {address1}
    {address1 && address2 && ' '}
    {address2}
  </div>
);

const NL = ({ street, number, aptNumber, address1, address2, city, zipcode, countryName }) => {
  const addressMarkup = hasAny(street, number) ? (
    <Street street={street} number={number} aptNumber={aptNumber} />
  ) : (
    <Address address1={address1} address2={address2} />
  );

  const cityMarkup = hasAny(city, zipcode) && (
    <div>
      {zipcode} {city}
    </div>
  );

  return (
    <Fragment>
      {addressMarkup}
      {cityMarkup}
      {!!countryName && <div>{countryName}</div>}
    </Fragment>
  );
};

export default NL;
